module.exports = __webpack_public_path__ + "static/media/desarolloevolutivo.8bca2ac7.svg";